<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3 pa-3">
      <v-card-title class="headline">Добавление Мастер-лицензии</v-card-title>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :complete="stepper > 1" step="1" color="green">Выбор Дилера и Модуля ПО</v-stepper-step>

          <v-divider></v-divider>

          <!--        <v-stepper-step :complete="stepper > 2" step="2" color="green">Модуль ПО</v-stepper-step>-->

          <!--        <v-divider></v-divider>-->

          <v-stepper-step step="2" color="green">Параметры</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form v-model="isDealerValid" ref="formDealer">
              <v-autocomplete
                  v-model="master.dealer"
                  :items="choices.dealers"
                  label="Дилер"
                  no-data-text="Дилер не найден"
                  :rules="[notEmptyRule]"
              ></v-autocomplete>

              <v-autocomplete
                  v-model="master.module"
                  :items="choices.modules"
                  label="Модуль ПО"
                  no-data-text="Модуль ПО не найден"
                  :rules="[notEmptyRule]"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.description">
                      {{ item.description }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>

              <v-textarea
                  class="mt-1"
                  label="Доп. инфо"
                  :value="selectedModuleDescription"
                  readonly
                  dense
                  auto-grow
                  rows="1"
                  hide-details
              ></v-textarea>
            </v-form>

            <div class="d-flex mt-4">
              <v-spacer></v-spacer>
              <v-btn
                  color="green"
                  text
                  @click="stepper = 2"
                  :disabled="!isDealerValid"
              >
                Далее
              </v-btn>
            </div>
          </v-stepper-content>

          <!--        <v-stepper-content step="2">-->
          <!--          <v-form v-model="isModuleValid" ref="formModule">-->
          <!--            <v-autocomplete-->
          <!--                v-model="master.module"-->
          <!--                :items="choices.modules"-->
          <!--                label="Модуль ПО"-->
          <!--                no-data-text="Модуль ПО не найден"-->
          <!--                :rules="[notEmptyRule]"-->
          <!--            ></v-autocomplete>-->
          <!--          </v-form>-->

          <!--          <div class="d-flex mt-4">-->
          <!--            <v-spacer></v-spacer>-->
          <!--            <v-spacer></v-spacer>-->
          <!--            <v-btn class="mr-4"-->
          <!--                   text-->
          <!--                   @click="stepper = 1"-->
          <!--            >-->
          <!--              Назад-->
          <!--            </v-btn>-->
          <!--            <v-btn-->
          <!--                color="green"-->
          <!--                text-->
          <!--                @click="stepper = 3"-->
          <!--                :disabled="!isModuleValid"-->
          <!--            >-->
          <!--              Далее-->
          <!--            </v-btn>-->
          <!--          </div>-->
          <!--        </v-stepper-content>-->

          <v-stepper-content step="2">
            <v-form v-model="isValid" ref="form">
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field label="Дилер"
                                v-if="master.dealer"
                                v-model="choices.dealers.find(_master => _master.value === master.dealer).text"
                                disabled
                                hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field label="Модуль ПО"
                                v-if="master.module"
                                v-model="choices.modules.find(_module => _module.value === master.module).text"
                                disabled
                                hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field label="Количество"
                                type="number"
                                v-model="master.count"
                                :rules="[notEmptyRule, positive]"
                                hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                      v-model="master.object"
                      :items="choices.objects"
                      label="Объект"
                      no-data-text="Объект не найден"
                      :rules="[notEmptyRule]"
                      hide-details
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-row>
                    <v-col cols="auto">
                      <v-checkbox
                        label="Шоурум"
                        v-model="master.showroom"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-if="master.showroom"
                        label="Деньги платит кому"
                        value="Никому, это шоурум"
                        readonly
                      ></v-text-field>
                      <v-select
                        v-else
                        label="Деньги платит кому"
                        :items="choices.ourLegalEntities"
                        v-model="master.moneyFor"
                        :rules="[notEmptyRule]"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    label="Доп. инфо"
                    class="pt-0"
                    :rows="3"
                    v-model="master.comment"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="7">
                  <v-card class="mx-1">
                    <v-card-title>Управление датой окончания</v-card-title>
                    <v-card-text>
                      <div class="d-flex justify-space-around flex-wrap">
                        <v-btn class="mb-4"
                               color="green"
                               dark
                               @click="addDays(10)"
                        >+10 дней
                        </v-btn>
                        <v-btn class="mb-4"
                               color="green"
                               dark
                               @click="addMonths(1)"
                        >+30 дней
                        </v-btn>
                        <v-btn class="mb-4"
                               color="green"
                               dark
                               @click="addMonths(3)"
                        >+3 мес
                        </v-btn>
                        <v-btn class="mb-4"
                               color="green"
                               dark
                               @click="addMonths(12)"
                        >+1 год
                        </v-btn>
                        <v-btn class="mb-4"
                               color="primary darken-2"
                               dark
                               @click="setMaxDate()"
                        >max дата
                        </v-btn>
                      </div>

                      <v-menu
                          ref="menu1"
                          v-model="dateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-bind="attrs"
                              v-on="on"
                              v-model="master.expires"
                              label="Мастер-лицензия действует включительно до"
                              prepend-icon="mdi-calendar"
                              :rules="[notEmptyRule]"
                              @blur="date = parseDate(master.expires)"
                              readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date"
                                       no-title
                                       @input="dateMenu = false"
                                       :first-day-of-week="1"
                                       locale="ru-RU"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="5" v-if="choices.features.length > 0">
                  <v-card class="mx-1">
                    <v-card-title class="pb-0">Управление фичами</v-card-title>
                    <v-card-text>
                      <v-checkbox
                          v-for="feature in choices.features"
                          :key="feature.id"
                          v-model="feature.included"
                          :label="feature.name"
                          hide-details
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>

            <div class="d-flex mt-4">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn class="mr-4"
                     text
                     @click="stepper--"
              >
                Назад
              </v-btn>
              <v-btn
                  color="green"
                  :dark="isValid"
                  :disabled="!isValid"
                  :loading="loading"
                  @click="createMaster"
              >
                Добавить
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>

    <v-dialog v-model="dateWarning" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Внимание</v-card-title>
        <v-card-text>Указанная дата окончания мастер-лицензии приходится на выходной день</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dateWarning = false">Продолжить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import {DUPLICATE_MASTER_SNACKBAR, objectHasMaster} from "@/utils/masters";

export default {
  name: 'MasterCreate',
  data() {
    return {
      stepper: 1,
      master: {
        dealer: null,
        module: null,
        count: 1,
        showroom: false,
        expires: this.formatDate(this.getIsoDate(new Date())),
      },
      choices: {
        dealers: [],
        modules: [],
        objects: [],
        features: [],
        ourLegalEntities: [],
      },
      isDealerValid: false,
      isModuleValid: false,
      isValid: false,
      loading: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      positive: v => (v && v > 0) || 'Только положительные числа',
      length100: v => (!v || v === '' || (v && v.length <= 100)) || 'Максимум 100 символов',

      dateWarning: false,
      date: this.getIsoDate(new Date()),
      dateMenu: false,
    }
  },
  computed: {
    selectedModuleDescription() {
      if (!this.master.module) {
        return '';
      }

      const selectedModule = this.choices.modules.find(
        module => module.value === this.master.module
      );

      return selectedModule && selectedModule.description ? selectedModule.description : '';
    },
  },
  watch: {
    date() {
      this.master.expires = this.formatDate(this.date);
      if (new Date(this.date).getFullYear() < 2100 && [6, 5].includes(new Date(this.date).getDay())) {
        this.dateWarning = true;
      }
    },
    'master.expires'() {
      this.date = this.parseDate(this.master.expires);
    },
    'master.dealer'() {
      if (this.master.dealer) {
        this.getObjectsChoices();
        this.getOurLegalEntitiesChoices();
      }
    },
    'master.module'() {
      if (this.master.module)
        this.getModuleFeaturesChoices();
    },
  },
  methods: {
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    addDays(days) {
      let date = new Date()
      this.date = this.getIsoDate(new Date(date.setDate(date.getDate() + days)))
    },
    addMonths(months) {
      let date = new Date()
      this.date = this.getIsoDate(new Date(date.setMonth(date.getMonth() + months)))
    },
    setMaxDate() {
      this.date = this.getIsoDate(new Date(Date.UTC(2100, 0, 1)))
    },
    getDealerChoices() {
      API.get('dealers/choices')
          .then((response) => {
            console.log(response.data);
            this.choices.dealers = response.data.choices;
            this.choices.dealers.forEach(choice => choice.text += ` (${choice.value})`);
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getModulesChoices() {
      API.get('modules/choices')
          .then((response) => {
            console.log(response.data);
            this.choices.modules = response.data.choices;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getObjectsChoices() {
      API.get(`dealers/${this.master.dealer}/objects/choices`)
          .then((response) => {
            console.log(response.data);
            this.choices.objects = response.data.choices;
            this.choices.objects.forEach(choice => choice.text += ` (${choice.value})`);
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getModuleFeaturesChoices() {
      API.get(`modules/${this.master.module}/features/choices`)
          .then((response) => {
            console.log(response.data);
            this.choices.features = response.data.choices;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getOurLegalEntitiesChoices() {
      API.get('our_legal_entities/list_for_choices')
        .then((response) => {
          console.log(response.data)
          this.choices.ourLegalEntities = response.data.choices
          API.get(`our_legal_entities/default_for_dealer/${this.master.dealer}`)
            .then((response) => {
              console.log(response.data)
              if (response.data.our_legal_entity) {
                this.master.moneyFor = response.data.our_legal_entity.id
              }
            })
            .catch((error) => {
              console.error(error)
            })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async createMaster() {
      this.loading = true;
      try {
        if (await objectHasMaster(this.master.object, this.master.module)) {
          this.$store.commit('showSnackbar', DUPLICATE_MASTER_SNACKBAR);
          return;
        }

        this.master.features = this.choices.features;
        const response = await API.post('masters/create', this.master);
        console.log(response.data);
        if (!response.data.success) {
          this.$store.commit('showSnackbar', DUPLICATE_MASTER_SNACKBAR);
          return;
        }

        this.$store.commit('showSnackbar', {
          color: 'success',
          text: 'Мастер-лицензия добавлена',
        })
        // this.$refs.formDealer.reset();
        // this.$refs.formModule.reset();
        //
        // this.master.object = null;
        // this.master.count = null;
        // this.master.moneyFor = null;
        // this.date = this.getIsoDate(new Date());
        // this.$refs.form.resetValidation();
        //
        // this.stepper = 1;
        this.$store.dispatch('updateMasters');
        this.$router.push('/masters');
      } catch (error) {
        console.log(error);
        this.$store.commit('showSnackbar', {
          color: 'error',
          text: 'Мастер-лицензия не добавлена',
        })
      } finally {
        this.loading = false;
      }
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'masters', disabled: false, to: '/masters', exact: true},
      {text: 'add', disabled: true},
    ])
  },
  created() {
    this.getDealerChoices();
    this.getModulesChoices();
  }
}
</script>

<style>
.v-stepper, .v-stepper__header {
  box-shadow: none !important;
}
</style>
